import { render, staticRenderFns } from "./Opcion.vue?vue&type=template&id=5f00c836"
import script from "./Opcion.vue?vue&type=script&lang=js"
export * from "./Opcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports